export const FEATURES = {
  EXAMPLE_FEATURE: 'exampleFeature',
} as const;

export type FeatureName = (typeof FEATURES)[keyof typeof FEATURES];

export interface FeatureConfig {
  name: FeatureName;
  defaultValue: boolean;
}

export const featureConfig: Record<FeatureName, FeatureConfig> = {
  [FEATURES.EXAMPLE_FEATURE]: { name: FEATURES.EXAMPLE_FEATURE, defaultValue: false },
};

export const getEnabledExperiments = () =>
  new URLSearchParams(window?.location?.search || '').getAll('experiment').filter(Boolean).join(',');

/**
 * Custom hook for checking if a feature is enabled via query parameter.
 *
 * Feature toggles are controlled only through the URL query parameter:
 * ?experiment=featureName
 *
 * @param {FeatureName} featureName - The name of the feature to check
 * @returns {boolean} Whether the feature is enabled
 *
 * @example
 * // In a React component:
 * const isExampleEnabled = isFeatureEnabled(FEATURES.EXAMPLE_FEATURE);
 *
 * // Use the feature state
 * if (isExampleEnabled) {
 *   // Do something when the feature is enabled
 * }
 */
const isFeatureEnabled = (featureName: FeatureName) => {
  const urlParams = new URLSearchParams(window?.location?.search || '');
  const experimentParam = urlParams.get('experiment');
  return experimentParam === featureName;
};

export default isFeatureEnabled;
